import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';
import AuthorizeDevice from '@/views/Pages/AuthorizeDevice.vue'
import ForgotPassword from '@/views/Pages/ForgotPassword.vue'
import ResetPassword from '@/views/Pages/ResetPassword.vue'
import CompleteRegistration from '@/views/Pages/CompleteRegistration.vue'

const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');


export default {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            meta: {guest: true},
            path: '/authorizeDevice',
            name: 'AuthorizeDevice',
            component: AuthorizeDevice,
        },
        {
            meta: {guest: true},
            path: '/forgotPassword',
            name: 'ForgotPasswordPage',
            component: ForgotPassword,
        },
        {
            meta: {guest: true},
            path: '/resetPassword',
            name: 'ResetPasswordPage',
            component: ResetPassword,
        },
        {
            meta: {guest: true},
            path: '/completeRegistration',
            name: 'CompleteRegistrationPage',
            component: CompleteRegistration,
        },
        {path: '*', component: NotFound}
    ]
};
